'use client';
import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

const ZoneChartInner = dynamic(() => import('./ZoneChartInner'), { ssr: false });

export default function ArenaZoneChart() {
  return <ZoneChartInner />;
}